export enum RecurrenceType {
  WEEKLY = 'weekly',
  SPECIFIC_DATE = 'specific date',
  CUSTOM = 'custom',
}

export type TimeUnit = 'days' | 'weeks' | 'months';
